import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CutCommand from './cutcommand';
import CutUI from './cutUI';

export default class Cut extends Plugin {
  static get pluginName() {
    return 'Cut';
  }

  static get requires() {
    return [ CutCommand, CutUI ];
  }
}
